import StackAPI from '@/lib/StackAPI'
import BatchSnapshot from '../types/BatchSnapshot'

export const UNKNOWN_ERROR = 'Failed to fetch batch snapshot'

export type BatchSnapshotParams = {
  batchId?: number
  batchIds?: number[]
}

type Batch = {
  vendor_sku: string
  product_name: string
  quantity: number
}

type Result = {
  data?: BatchSnapshot[]
  error?: string
}

const getBatchSnapshot = async ({
  batchId,
  batchIds
}: BatchSnapshotParams): Promise<Result> => {
  const path = batchId
    ? `/partners/vendor/batches/${batchId}/snapshot`
    : '/partners/vendor/batches/snapshot'

  const { get } = StackAPI()

  return get({ path, params: { ids: batchIds } })
    .then(({ data, status }) => {
      if (status < 200 || status >= 300) {
        return { error: UNKNOWN_ERROR }
      }

      return { data: parseData(data.products) }
    })
    .catch(() => ({ error: UNKNOWN_ERROR }))
}

const parseData = (data: Batch[]): BatchSnapshot[] => {
  return data.map((item: Batch) => ({
    sku: item.vendor_sku,
    product: item.product_name,
    quantity: item.quantity
  }))
}

export default getBatchSnapshot
